import React, { Component } from "react";
import { get as _get, isEqual as _isEqual } from "lodash";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { updateLoadingState, updatePageLevelLoadingState } from "../../redux/actions/application";

import { fetchLogo, getInitials, downloadExcelFile } from "../../helpers/utils";
import { hasAccess } from "../../resusableComponents/hoc/AccessManagement";

import { getCompanyCardDetail, doGetCampaignListByClient, doGenerateCompanyCardDeepResearch, doDownloadCompanyCardDeepResearch } from "../../redux/services/campaign";

import { showAlertMessage, Select } from "../../resusableComponents/common/formElements";
import { withRouter } from "../../resusableComponents/hoc/withRouter";
//import BuyerIntelligence from "./components/BuyerIntelligence";
import Overview from "./components/Overview";
import KeyContacts from "./components/KeyContacts";
import TechStack from "./components/TechStack";

//import IconBuyerIntelligency from "../../assets/icons/icon-buyer-intelligence.svg";
import IconKeyContact from "../../assets/icons/icon-key-contact.svg";
import IconTechStack from "../../assets/icons/icon-tech-stack.svg";
import IconCategory from "../../assets/icons/icon-category.svg";
import IconLocation from "../../assets/icons/icon-location.svg";
import IconComapany from "../../assets/icons/icon-company.svg";
import IconDowload from "../../assets/icons/icon-download.svg";
import IconWebsite from "../../assets/icons/icon-website.svg";

class CompanyCard extends Component {

  constructor(props) {
    super(props);

    this.state = {
      clientId: _get(this.props, "params.clientId", 0),
      campaignId: _get(this.props, "params.campaignId", 0),
      companyCardId: _get(this.props, "params.companyCardId", 0),
      activeTab: "overview",
      showResearchModal: false,
      companyCardDetail: {},
      campaignList: [],
      selectedCampaigns: null,
      activeRequestCount: 0,
      logoError: false,
    };
  }

  componentDidMount() {
    this._fetchCampaignList();
  }

  componentDidUpdate(prevProps, prevState) {
    const { activeTab } = this.state;

    // Re-fetch only when switching TO overview or contacts; skip for tech & intelligence
    if (!_isEqual(prevState.activeTab, this.state.activeTab) && (activeTab === "overview" || activeTab === "contacts")) {
      this._fetchCompanyCardDetail();
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchCompanyCardDetail = async () => {
    const { clientId, selectedCampaigns, companyCardId } = this.state;

    try {
      this._incrementLoader();

      const response = await getCompanyCardDetail({
        company_card_id: (companyCardId || ""),
        client_id: (clientId || 0),
        campaign_ids: (selectedCampaigns && selectedCampaigns.length > 0) ? (selectedCampaigns || []).map(c => String(c.id)) : [],
      });

      if ((response.flag || false) === true) {
        this.setState({ companyCardDetail: _get(response, "data", {}), logoError: false });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching company card detail."));
        this.setState({ companyCardDetail: {}, logoError: false });
      }
    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching company card detail."));
    } finally {
      this._decrementLoader();
    }
  }

  _fetchCampaignList = async () => {
    const { clientId, campaignId } = this.state;
    if (!clientId) return;

    try {
      this._incrementLoader();
      const response = await doGetCampaignListByClient({ client_id: clientId, search_text: "" });
      if ((response.flag || false) === true) {
        const campaignData = _get(response, "data.responseData", []);
        let defaultSelected = null;
        if ((campaignData) && ((campaignData || []).length > 0) && (campaignId)) {
          const found = (campaignData || []).find(c => String(c.id) === String(campaignId));
          if (found) {
            defaultSelected = [found];
          }
        }
        this.setState({
          campaignList: campaignData,
          selectedCampaigns: defaultSelected
        }, () => {
          this._fetchCompanyCardDetail();
        });
      } else {
        this._fetchCompanyCardDetail();
      }
    } catch (error) {
      console.error("Error fetching campaign list", error);
      this._fetchCompanyCardDetail();
    } finally {
      this._decrementLoader();
    }
  };

  _handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  _handleDeepResearch = () => {
    this.setState({ showResearchModal: true });
  };

  _handleCloseModal = () => {
    this.setState({ showResearchModal: false });
  };

  _handleGenerateDeepResearch = async () => {
    const { intl, updateLoadingState } = this.props;
    const { companyCardDetail } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGenerateCompanyCardDeepResearch(_get(companyCardDetail, "company_id", ""));

      if (_get(response, "flag", false) === true) {
        showAlertMessage(
          _get(response, "message", intl.formatMessage({ id: "company_card.deep_research.success.generate", defaultMessage: "Deep research generation initiated successfully." })),
          "success"
        );
        this._fetchCompanyCardDetail();
      } else {
        showAlertMessage(
          _get(response, "message", intl.formatMessage({ id: "company_card.deep_research.error.generate", defaultMessage: "Something went wrong while generating deep research." }))
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", intl.formatMessage({ id: "company_card.deep_research.error.generate", defaultMessage: "Something went wrong while generating deep research." }))
      );
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _handleViewDeepResearchReport = async () => {
    const { intl, updateLoadingState } = this.props;
    const { companyCardDetail } = this.state;

    try {
      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doDownloadCompanyCardDeepResearch(_get(companyCardDetail, "company_id", ""));

      if (_get(response, "flag", false) === true) {
        const downloadFileDetails = _get(response, "data", {});
        const contentType = _get(downloadFileDetails, "contentType", "");
        const contents = _get(downloadFileDetails, "Contents", "");
        const filename = _get(downloadFileDetails, "filename", "");

        if ((contentType !== "") && (contents !== "") && (filename !== "")) {
          downloadExcelFile(contentType, contents, filename);
          showAlertMessage(
            _get(response, "message", intl.formatMessage({ id: "company_card.deep_research.success.download", defaultMessage: "Deep research report downloaded successfully." })),
            "success"
          );
        } else {
          showAlertMessage(
            intl.formatMessage({ id: "company_card.deep_research.error.download", defaultMessage: "Something went wrong while downloading deep research report." })
          );
        }
      } else {
        showAlertMessage(
          _get(response, "message", intl.formatMessage({ id: "company_card.deep_research.error.download", defaultMessage: "Something went wrong while downloading deep research report." }))
        );
      }
    } catch (error) {
      showAlertMessage(
        _get(error, "message", intl.formatMessage({ id: "company_card.deep_research.error.download", defaultMessage: "Something went wrong while downloading deep research report." }))
      );
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  /* ── Header card ──────────────────────────────────────────── */
  _renderHeaderCard = () => {
    const { companyCardDetail, logoError } = this.state;
    const companyName = _get(companyCardDetail, "company", "");
    const domain = _get(companyCardDetail, "domain", "");
    const logoUrl = fetchLogo(domain);
    const initials = getInitials(companyName);
    const deepResearchStatus = _get(companyCardDetail, "deep_research_report_status", null);
    const hasDeepResearchAccess = hasAccess("campaigns", "company-card", ["deep-research-report"]);

    return (
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-4">

                {/* Left: Logo + info */}
                <div className="d-flex align-items-center gap-4">
                  <div
                    className="d-flex align-items-center justify-content-center bg-dark text-white fw-bold rounded overflow-hidden company-card-logo-avatar"
                  >
                    {(logoUrl && !logoError) ? (
                      <img
                        src={logoUrl}
                        alt={`${companyName} logo`}
                        className="company-card-logo-img"
                        onError={() => this.setState({ logoError: true })}
                      />
                    ) : initials}
                  </div>
                  <div>
                    <div className="d-flex flex-wrap align-items-center gap-3 mb-1">
                      <h1 className="heading-03 fw-bold text-black mb-0">{_get(companyCardDetail, "company", "")}</h1>
                    </div>
                    <div className="d-flex flex-wrap gap-4 text-muted fw-medium">
                      <span className="d-inline-flex gap-2 align-items-center">
                        <img src={IconWebsite} alt={`${_get(companyCardDetail, "industry", "")} icon`} width="16" />
                        {_get(companyCardDetail, "domain", "")}</span>
                      <span className="d-inline-flex gap-2 align-items-center">
                        <img src={IconCategory} alt={`${_get(companyCardDetail, "industry", "")} icon`} width="16" />
                        {_get(companyCardDetail, "industry", "")}
                      </span>
                      <span className="d-inline-flex gap-2 align-items-center">
                        <img src={IconLocation} alt={`${_get(companyCardDetail, "address", "")} icon`} width="16" />
                        {_get(companyCardDetail, "address", "")}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right: Action buttons */}
                <div className="d-flex flex-wrap gap-2">

                  {(hasDeepResearchAccess) && (_get(companyCardDetail, "is_deep_research_report_visible", false) === true) && (
                    <>
                      {((deepResearchStatus === "Pending") || (deepResearchStatus === "Failed") || (deepResearchStatus === null)) && (
                        <button
                          className="btn btn-outline-primary waves-effect text-capitalize px-4"
                          onClick={() => this._handleGenerateDeepResearch()}
                        >
                          <FormattedMessage id="company_card.header.btn.generate_deep_research" defaultMessage="Generate Deep Research" />
                        </button>
                      )}

                      {(deepResearchStatus === "In progress") && (
                        <button
                          className="btn btn-outline-secondary waves-effect text-capitalize px-4"
                          disabled
                        >
                          <FormattedMessage id="company_card.header.btn.view_deep_research_report" defaultMessage="View Deep Research Report" />
                        </button>
                      )}

                      {(deepResearchStatus === "Generated") && (
                        <button
                          className="btn btn-outline-primary waves-effect text-capitalize px-4"
                          onClick={() => this._handleViewDeepResearchReport()}
                        >
                          <FormattedMessage id="company_card.header.btn.view_deep_research_report" defaultMessage="View Deep Research Report" />
                        </button>
                      )}
                    </>
                  )}

                  <button
                    className="btn btn-secondary waves-effect text-capitalize px-4"
                    onClick={() => window.print()}
                  >
                    <img src={IconDowload} alt="Download Icon" width="16" />
                    <FormattedMessage id="company_card.header.btn.export_pdf" defaultMessage="Export PDF" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* ── Tabs nav ─────────────────────────────────────────────── */
  _renderTabs = () => {
    const { intl } = this.props;
    const { activeTab } = this.state;

    const tabDefs = [
      { id: "overview", labelId: "company_card.tab.overview", icon: IconComapany },
      //{ id: "intelligence", labelId: "company_card.tab.intelligence", icon: IconBuyerIntelligency },
      { id: "tech", labelId: "company_card.tab.tech_stack", icon: IconTechStack },
      { id: "contacts", labelId: "company_card.tab.contacts", icon: IconKeyContact },
    ];

    return (
      <ul className="nav nav-tabs" id="companyCardTab" role="tablist">
        {tabDefs.map((tab) => (
          <li className="nav-item" key={tab.id}>
            <button
              className={`nav-link text-capitalize ${tab.id === activeTab ? "active" : ""}`}
              onClick={() => this._handleTabChange(tab.id)}
            >
              <img src={tab.icon} alt={`${tab.labelId} icon`} />
              {intl.formatMessage({ id: tab.labelId })}
            </button>
          </li>
        ))}
      </ul>
    );
  };

  /* ── Tab content dispatcher ───────────────────────────────── */
  _renderTabContent = () => {
    const { activeTab, clientId, campaignId } = this.state;

    const { companyCardDetail } = this.state;

    return (
      <div className="tab-content">
        {((activeTab || "") === "overview") && <Overview companyCardDetail={(companyCardDetail || {})} clientId={(clientId || 0)} campaignId={(campaignId || 0)} />}
        {/*(activeTab || "") === "intelligence" && <BuyerIntelligence />*/}
        {((activeTab || "") === "tech") && <TechStack techStack={_get(companyCardDetail, "tech_stack", [])} />}
        {((activeTab || "") === "contacts") && <KeyContacts companyCardDetail={(companyCardDetail || {})} />}
      </div>
    );
  };

  /* ── Deep Research Modal ──────────────────────────────────── */
  _renderDeepResearchModal = () => {
    const { companyCardDetail, showResearchModal } = this.state;
    const companyName = _get(companyCardDetail, "company", "");

    if (!showResearchModal) { return null; }

    return (
      <div className="modal fade show d-block company-card-modal-backdrop" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold d-flex align-items-center gap-2">
                <i className="ti ti-sparkles text-primary" />
                <FormattedMessage id="company_card.deep_research.title" defaultMessage="Deep Research:" />
                {" "}{(companyName || "")}
              </h5>
              <button type="button" className="btn-close" onClick={this._handleCloseModal} />
            </div>
            <div className="modal-body p-5">
              <h4 className="fw-bold text-dark mb-4">
                <FormattedMessage id="company_card.deep_research.intelligence_title" defaultMessage="Engagement Intelligence" />
              </h4>
              <div className="alert alert-primary mb-4">
                <p className="mb-0">
                  Target is currently migrating to <strong>S/4HANA</strong> and implementing <strong>BIMcollab Nexus</strong> for major infrastructure projects like Hinkley Point C. Their digital leadership is highly focused on <em>Modern Methods of Construction</em> (MMC).
                </p>
              </div>
            </div>
            <div className="modal-footer gap-2">
              <button className="btn btn-light text-capitalize waves-effect" onClick={this._handleCloseModal}>
                <i className="ti ti-database me-1" />
                <FormattedMessage id="company_card.deep_research.btn.push_to_fabric" defaultMessage="Push to Fabric" />
              </button>
              <button className="btn btn-dark text-capitalize waves-effect" onClick={this._handleCloseModal}>
                <i className="ti ti-sparkles me-1 text-warning" />
                <FormattedMessage id="company_card.deep_research.btn.generate_email" defaultMessage="Generate Email" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { intl } = this.props;
    const { selectedCampaigns, campaignList, campaignId } = this.state;

    const campaignName = (selectedCampaigns && selectedCampaigns.length > 0)
      ? selectedCampaigns.map(c => c.name).join(", ")
      : "All Campaigns";

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "funnel.company_card", defaultMessage: "Company Card: Funnel Fuel" })}
          </title>
          <style type="text/css" media="print">
            {`
              body * {
                visibility: hidden;
              }
              .company-card-section, .company-card-section * {
                visibility: visible;
              }
              .company-card-section {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
              }
            `}
          </style>
        </Helmet>

        <div className="container-fluid flex-grow-1 px-6 py-6">

          {/* Campaign filter context bar */}
          <div className="row mb-4">
            <div className="col-lg-12">
              <div className="d-flex flex-wrap gap-3 align-items-center">
                <div className="input-group w-auto">
                  <span className="input-group-text bg-primary border-primary ps-3 d-flex align-items-center input-group-rounded">
                    <img src={require("../../assets/icons/icon-dashboard-alt.svg").default} className="img-fluid" alt="img" />
                  </span>
                  <Link to={`/campaigns/dashboard/${campaignId}`} className="btn btn-primary waves-effect">
                    <FormattedMessage id="campaign_content.btn.campaign_dashboard" defaultMessage="campaign dashboard" />
                  </Link>
                </div>
                <div className="input-group w-auto">
                  <span className="input-group-text bg-primary border-primary ps-3 d-flex align-items-center input-group-rounded">
                    <img src={require("../../assets/icons/icon-dashboard-alt.svg").default} className="img-fluid" alt="img" />
                  </span>
                  <Link to={`/campaigns/view-leads/${campaignId}`} className="btn btn-primary waves-effect">
                    <FormattedMessage id="campaign_dashboard.btn.view_leads" defaultMessage="View Leads" />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-lg-6">
              <p className="mb-0 fw-bold text-dark">
                <FormattedMessage id="company_card.filter.viewing_dataset_for" defaultMessage="Viewing limited dataset for:" />
                {" "}
                <span className="text-primary">{campaignName}</span>
              </p>
            </div>

            <div className="col-lg-6">
              <div className="d-flex align-items-center justify-content-end gap-2">
                <span className="text-muted text-nowrap text-uppercase fw-bold">
                  <FormattedMessage id="company_card.filter.campaign_filter" defaultMessage="Campaign Filter:" />
                </span>
                <div className="company-card-campaign-select">
                  <Select
                    className="form-custom-select text-capitalize"
                    placeholder={intl.formatMessage({ id: "label.select_field", defaultMessage: "select {field}" }, { field: "Campaigns" })}
                    options={(campaignList || [])}
                    value={(selectedCampaigns || null)}
                    getOptionLabel={(option) => (option.name || "")}
                    getOptionValue={(option) => (option.id || null)}
                    onChange={(selected) => this.setState({ selectedCampaigns: selected || null }, () => this._fetchCompanyCardDetail())}
                    isMulti={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="company-card-section">
            {/* Company header card */}
            {this._renderHeaderCard()}

            {/* Tabs + content */}
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    {this._renderTabs()}
                    {this._renderTabContent()}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Deep Research Modal */}
        {this._renderDeepResearchModal()}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default withRouter(connect(null, mapDispatchToProps)(injectIntl(CompanyCard)));
